import React from 'react';
import { faSadCry } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './CryButton.module.css';
import { CommonButton } from '_components';


export class CryButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : ''} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faSadCry} transform="shrink-6" color="#717271" />
            </CommonButton>
        );
    }
}
